import useSWR from 'swr';

import { useAxios } from './axiosApi';
import { useAuth } from './useAuth';

export const USER_TILING_INCLUDED = true;

export function useUser(userId) {
  const { user, isAuthenticated } = useAuth();

  const { apiGet } = useAxios();

  // If userId is not specified, use the current user.
  const userIdQuery = userId ?? user?.sub;

  const { data: userItem, error, mutate } = useSWR(
    isAuthenticated && userIdQuery ? ['/account', { params: { userId: userIdQuery, createIfNeeded: true } }] : null,
    async ([path, config]) => {
      const response = await apiGet(path, config);
      if (response.data?.status !== 'success') {
        const error = new Error(response.data?.message || 'API request failed');
        error.response = response;
        throw error;
      }
      return response.data?.data;
    },
    // { refreshInterval: 300000 },
  );

  return {
    userItem,
    error,
    mutate,
  }
}

export function useAllUsers() {
  const { isAuthenticated } = useAuth();

  const { apiGet } = useAxios();
  const { userItem } = useUser();

  const { data: allUserItems, error, mutate } = useSWR(
    isAuthenticated && userItem && userItem.staff ? ['/account', {}] : null,
    async ([path, config]) => {
      const response = await apiGet(path, config);
      if (response.data?.status !== 'success') {
        throw new Error(response.data?.message);
      }
      return response.data?.data;
    }
  );

  return {
    allUserItems,
    error,
    mutate,
  }
}

export function useUserApi() {
  const { apiPut } = useAxios();
  const { userItem, mutate } = useUser();

  return {
    putUiSettings: async (userId, uiSettings) => {
      if (!userId || !uiSettings || !userItem) {
        return false;
      }
      const data = { uiSettings: { ...userItem?.uiSettings, ...uiSettings } };
      const reponse = await apiPut('/account', data, {
        params: { userId },
      });
      const { status, _data } = reponse.data;
      const putSuccess = (status === 'success');
      if (putSuccess) {
        mutate();
      }
      return putSuccess;
    },
  }
}

export function useStripeClientSecret(userId) {
  const { user, isAuthenticated } = useAuth();

  const { apiGet } = useAxios();

  // If userId is not specified, use the current user.
  const userIdQuery = userId ?? user?.sub;

  const { data: clientSecret, error} = useSWR(
    isAuthenticated && userIdQuery ? ['/customer', { params: { userId: userIdQuery } }] : null,
    async ([path, config]) => {
      const response = await apiGet(path, config);
      if (response.data?.status !== 'success') {
        throw new Error(response.data?.message);
      }
      return response.data?.data;
    },
    // By default, Stripe customer sessions expire after 24 hours.
    { refreshInterval: 24*60*60*1000 },
  );

  return {
    clientSecret,
    error,
  }
}
